module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#043f61"
					},
					{
						"y": 84.21052631578947,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.57894736842105,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.42105263157895,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#09472e"
					},
					{
						"y": 55.26315789473685,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.23664122137404,
						"dataLabels": {
							"enabled": false,
							"format": "130"
						},
						"color": "#043f61"
					},
					{
						"y": 81.67938931297711,
						"dataLabels": {
							"enabled": false,
							"format": "107"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.86259541984732,
						"dataLabels": {
							"enabled": false,
							"format": "102"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.51908396946564,
						"dataLabels": {
							"enabled": false,
							"format": "95"
						},
						"color": "#09472e"
					},
					{
						"y": 58.01526717557252,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.1304347826087,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#043f61"
					},
					{
						"y": 95.65217391304348,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.56521739130436,
						"dataLabels": {
							"enabled": false,
							"format": "103"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.6086956521739,
						"dataLabels": {
							"enabled": false,
							"format": "95"
						},
						"color": "#09472e"
					},
					{
						"y": 65.21739130434783,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "474"
						},
						"color": "#043f61"
					},
					{
						"y": 94.09282700421942,
						"dataLabels": {
							"enabled": false,
							"format": "446"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.66244725738397,
						"dataLabels": {
							"enabled": false,
							"format": "425"
						},
						"color": "#0d4440"
					},
					{
						"y": 88.39662447257383,
						"dataLabels": {
							"enabled": false,
							"format": "419"
						},
						"color": "#09472e"
					},
					{
						"y": 73.41772151898735,
						"dataLabels": {
							"enabled": false,
							"format": "348"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#043f61"
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0c4250"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0d4440"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#043f61"
					},
					{
						"y": 97.67441860465115,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0c4250"
					},
					{
						"y": 94.18604651162791,
						"dataLabels": {
							"enabled": false,
							"format": "81"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.6046511627907,
						"dataLabels": {
							"enabled": false,
							"format": "59"
						},
						"color": "#09472e"
					},
					{
						"y": 47.674418604651166,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.53488372093024,
						"dataLabels": {
							"enabled": false,
							"format": "214"
						},
						"color": "#043f61"
					},
					{
						"y": 89.76744186046511,
						"dataLabels": {
							"enabled": false,
							"format": "193"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.65116279069768,
						"dataLabels": {
							"enabled": false,
							"format": "182"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.48837209302326,
						"dataLabels": {
							"enabled": false,
							"format": "158"
						},
						"color": "#09472e"
					},
					{
						"y": 47.906976744186046,
						"dataLabels": {
							"enabled": false,
							"format": "103"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.78947368421053,
						"dataLabels": {
							"enabled": false,
							"format": "474"
						},
						"color": "#043f61"
					},
					{
						"y": 88.63157894736841,
						"dataLabels": {
							"enabled": false,
							"format": "421"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.68421052631578,
						"dataLabels": {
							"enabled": false,
							"format": "407"
						},
						"color": "#0d4440"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "380"
						},
						"color": "#09472e"
					},
					{
						"y": 58.31578947368421,
						"dataLabels": {
							"enabled": false,
							"format": "277"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 65.67164179104478,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 59.70149253731343,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#0c4250"
					},
					{
						"y": 55.223880597014926,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0d4440"
					},
					{
						"y": 44.776119402985074,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 20.8955223880597,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.09523809523809,
						"dataLabels": {
							"enabled": false,
							"format": "103"
						},
						"color": "#043f61"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "90"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.9047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "86"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.19047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "80"
						},
						"color": "#09472e"
					},
					{
						"y": 51.42857142857142,
						"dataLabels": {
							"enabled": false,
							"format": "54"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.49238578680203,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#043f61"
					},
					{
						"y": 81.7258883248731,
						"dataLabels": {
							"enabled": false,
							"format": "161"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.66497461928934,
						"dataLabels": {
							"enabled": false,
							"format": "153"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.05076142131979,
						"dataLabels": {
							"enabled": false,
							"format": "138"
						},
						"color": "#09472e"
					},
					{
						"y": 49.746192893401016,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.3451536643026,
						"dataLabels": {
							"enabled": false,
							"format": "416"
						},
						"color": "#043f61"
					},
					{
						"y": 79.66903073286052,
						"dataLabels": {
							"enabled": false,
							"format": "337"
						},
						"color": "#0c4250"
					},
					{
						"y": 74.94089834515366,
						"dataLabels": {
							"enabled": false,
							"format": "317"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.10401891252955,
						"dataLabels": {
							"enabled": false,
							"format": "305"
						},
						"color": "#09472e"
					},
					{
						"y": 56.26477541371159,
						"dataLabels": {
							"enabled": false,
							"format": "238"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.789473684210531,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.129032258064512,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.23076923076923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.7633587786259555,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.692307692307697,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.672897196261683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.8627450980392135,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8695652173912993,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.508771929824561,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.36363636363636,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.7669902912621325,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.052631578947366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.907172995780585,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.7085201793722,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.4117647058823568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.945107398568016,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.46153846153846,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3255813953488413,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.160493827160494,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.508474576271183,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.46511627906976605,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.813084112149529,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.699481865284972,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.186813186813184,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.81012658227848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.21052631578947212,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.181434599156114,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.32541567695962,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.633906633906639,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.105263157894733,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -34.32835820895522,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.499999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.918918918918916,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -53.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.904761904761909,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.621359223300976,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.444444444444439,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.976744186046513,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -32.49999999999999,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.5076142131979711,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.968944099378881,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.80392156862745,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.985507246376805,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.654846335697402,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.990384615384613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.934718100890213,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.785488958990535,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.967213114754102,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=38"
			},
			{
				"x": 9,
				"text": "30-39<br>n=131"
			},
			{
				"x": 15,
				"text": "40-49<br>n=115"
			},
			{
				"x": 21,
				"text": ">=50<br>n=474"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=20"
			},
			{
				"x": 34,
				"text": "30-39<br>n=86"
			},
			{
				"x": 40,
				"text": "40-49<br>n=215"
			},
			{
				"x": 46,
				"text": ">=50<br>n=475"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=67"
			},
			{
				"x": 59,
				"text": "30-39<br>n=105"
			},
			{
				"x": 65,
				"text": "40-49<br>n=197"
			},
			{
				"x": 71,
				"text": ">=50<br>n=423"
			}
		],
		"dataTable": {
			"MSM:<30": [
				38,
				38,
				32,
				31,
				26,
				21
			],
			"MSM:30-39": [
				131,
				130,
				107,
				102,
				95,
				76
			],
			"MSM:40-49": [
				115,
				114,
				110,
				103,
				95,
				75
			],
			"MSM:>=50": [
				474,
				474,
				446,
				425,
				419,
				348
			],
			"Non-MSM:<30": [
				20,
				20,
				14,
				13,
				13,
				8
			],
			"Non-MSM:30-39": [
				86,
				86,
				84,
				81,
				59,
				41
			],
			"Non-MSM:40-49": [
				215,
				214,
				193,
				182,
				158,
				103
			],
			"Non-MSM:>=50": [
				475,
				474,
				421,
				407,
				380,
				277
			],
			"Unknown:<30": [
				67,
				44,
				40,
				37,
				30,
				14
			],
			"Unknown:30-39": [
				105,
				103,
				90,
				86,
				80,
				54
			],
			"Unknown:40-49": [
				197,
				196,
				161,
				153,
				138,
				98
			],
			"Unknown:>=50": [
				423,
				416,
				337,
				317,
				305,
				238
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_5.json
// module id = 204
// module chunks = 0